import withTracker from '.././withTracker';
import Unauthenticated from '../../containers/subscriber/Unauthenticated';

const subscriberUnauthenticated = {
  path: '/subscribers/unauthenticated',
  component: withTracker(Unauthenticated)
};

export default subscriberUnauthenticated;
